module.exports = __webpack_public_path__ + "static/media/laxmirajmv1.b5c9fa2d.png";